import { Market } from '@oneaudi/avp-models';
import { cupraConfiguratorSites, cupraLegalNoticeSites } from '../constants/Locales';

export const getCupraConfiguratorWebsite = (configurationId?: string, market?: Market) => {
  const configuratorSite =
    cupraConfiguratorSites.get(market || Market.DEU) || cupraConfiguratorSites.get(Market.DEU);

  return `${configuratorSite}&id=${configurationId}`;
};
export const getCupraLegalNoticeWebsite = (market?: Market) => {
  return (
    cupraLegalNoticeSites.get(market || Market.DEU) || 'https://www.cupraofficial.com/legal-note'
  );
};
